<template>
  <div class="page protocol">
    <navigation>委托扣款协议</navigation> 
    <entrust></entrust>
    <p
      data-sensors-exposure-property-page_status="page_bottom"
      data-sensors-exposure-event-name="general_event"
    >&nbsp;<!-- 监听协议滑动到了底部，每个协议都加上--></p>
  </div>
</template>
<script>
export default {
  name: 'entrust-protocol',
  components: {
    entrust: () => import('@/view/protocol/components/entrust.vue')
  },
  created () {
    this.$bus.$emit('ready')
  }
}
</script>